var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/tutorial/viewmodels/startuptutorial',["require", "exports", "common/viewmodelbase", "plugins/dialog", "models/portal", "models/account"], function (require, exports, ViewModel, Dialog, Portal, Account) {
    "use strict";
    var StartupTutorialViewModel = (function (_super) {
        __extends(StartupTutorialViewModel, _super);
        //#region ctor
        function StartupTutorialViewModel() {
            _super.call(this);
            this._shell = Portal.Context.shell;
            this._userManager = this._shell.userManager;
            if (Account.Session.principal.memberType === 'client_postmaster') {
                //Introduction tutorial for Client
                this.introductionTutorialUrl = "https://cch-tutorials-dev.azurewebsites.net/one-click/client-tutorial/home.html";
                this._settingsKey = "TutorialClient";
            }
            else if (Account.Session.principal.memberType === 'stb_postmaster' || Account.Session.principal.memberType === 'stb_admin') {
                //Introduction tutorial for Employee
                this.introductionTutorialUrl = "https://cch-tutorials-dev.azurewebsites.net/one-click/practice-tutorial/home.html";
                this._settingsKey = "TutorialEmployee";
            }
        }
        //#endregion
        StartupTutorialViewModel.prototype.onActivated = function (context) {
            return Q(true);
        };
        StartupTutorialViewModel.prototype.close = function () {
            // update show-tutorial info in database  
            this._userManager.saveSettings(this._settingsKey, { executed: true });
            Dialog.close(this);
        };
        return StartupTutorialViewModel;
    }(ViewModel.ViewModelBase));
    var instance = new StartupTutorialViewModel();
    return instance;
});

